import { DataSourceHttpError } from '@rammetec/data-access';
import { ValidationException } from './validationException.js';
/** Domain field name → physical snake_case (matches system-api `toColumn`). */
function fieldToSnake(fieldName) {
    return fieldName
        .replace(/-/g, '_')
        .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
        .replace(/([A-Z])([A-Z][a-z])/g, '$1_$2')
        .toLowerCase();
}
/**
 * Whether a PG unique-index name (`idx_<table>_<column>_uq`) targets `uniqueField`.
 * Request 0322 — constraint suffix identifies the field.
 */
export function constraintMatchesUniqueField(constraint, uniqueField) {
    if (!constraint)
        return false;
    return constraint.endsWith(`_${fieldToSnake(uniqueField)}_uq`);
}
function readConstraint(error) {
    if (error.body && typeof error.body === 'object') {
        const record = error.body;
        if (typeof record.constraint === 'string')
            return record.constraint;
    }
    return undefined;
}
/**
 * Maps a `/pg` unique_violation (HTTP 409, index `…_uq`) to the same
 * {@link ValidationException} that {@link assertCodeUniquePerOrg} throws.
 * Returns `null` when the error is unrelated (caller rethrows).
 */
export function validationExceptionFromUniqueCodeViolation(error, opts) {
    if (!(error instanceof DataSourceHttpError))
        return null;
    if (error.code !== 'unique_violation')
        return null;
    if (!opts.uniqueField)
        return null;
    if (!constraintMatchesUniqueField(readConstraint(error), opts.uniqueField))
        return null;
    const code = opts.attemptedCode != null && opts.attemptedCode !== ''
        ? Number(opts.attemptedCode)
        : undefined;
    const details = code != null && !Number.isNaN(code) ? { code } : undefined;
    return new ValidationException(`Já existe ${opts.entityLabel} com o código informado.`, details);
}
//# sourceMappingURL=mapUniqueCodeViolation.js.map